import { IQuote, IQuoteData, QuoteOrganizationEnum } from '../quote.types';
import { Quote } from '../quote';
import { ITransition } from '@/models/transition';
import { IQuotePaginatedListData } from '@/services';

export const mockQuotesData = (): IQuoteData[] => [
  {
    number: 258,
    revision: 2,
    language: 'en',
    latest: true,
    owner: 'Lamar Falconer',
    state: 10,
    type: 0,
    layout: 'Layout 1',
    project: 'Layout 2',
    rfq_date: '2021-12-01',
    rfq_number: '123456',
    validity_date_range: 30,
    exchange_rate: 1.0,
    currency: 1,
    customer: {
      id: 2,
      name: 'Test Inc',
      identifier: '',
      tax_id: '',
      is_same_billing_address: true,
      address: {
        id: 3,
        address1: '123 Main St',
        address2: '',
        address3: '',
        address4: '',
        city: 'Toronto',
        region: 'ON',
        country: 'Canada',
        postal_code: 'T5T 1V2'
      },
      ship_address: {
        id: 4,
        address1: '123 Main St',
        address2: '',
        address3: '',
        address4: '',
        city: 'Toronto',
        region: 'ON',
        country: 'Canada',
        postal_code: 'T5T 1V2'
      },
      contact: {
        id: 2,
        first_name: 'Lamar',
        last_name: 'Falconer',
        email: '',
        phone: ''
      }
    },
    region: null,
    ewg_discount_percent: 0.0,
    ewg_discount: 0.0,
    special_discount_percent: 0.0,
    special_discount: 0.0,
    commission_percent: 0.0,

    equipment_subtotal: 0.0,
    subscription_first_year_discount: 0.0,
    subscription_yearly_subtotal: 0.0,

    commission: 0.0,
    comments: '',
    categories: [
      {
        id: 344,
        module: 4,
        price: 27000.0,
        global_discount_percentage: 0.0,
        accessory_discount_percentage: 0.0,
        first_year_subscription_discount_percentage: 100.0,
        discount: 0.0,
        products: [
          {
            id: 355,
            description: '',
            quantity: 1,
            price: 27000.0,
            module: 4,
            configuration: 923
          }
        ],
        accessory_discount: 0.0,
        accessory_price: 27000.0,
        global_discount: 0,
        global_price: 0
      }
    ],
    service_items: [],
    freight_items: [],
    extra_items: [],
    terms: [],
    payment_terms: [],
    rooms: [],
    capacity: {
      incubation_chiller_capacities_kw: 0,
      ventilation_chiller_capacities_kw: 0,
      incubation_boiler_capacities_kw: 0,
      ventilation_boiler_capacities_kw: 0,
      summer_temp_c: 0,
      summer_temp_f: 0,
      winter_temp_c: 0,
      winter_temp_f: 0,
      summer_rh: 0,
      winter_rh: 0,
      voltage_phase_frequency: '',
      boiler_type: '',

      ventilation_chiller_capacities_ton: 0,
      incubation_chiller_capacities_ton: 0,
      ventilation_boiler_capacities_mbh: 0,
      incubation_boiler_capacities_mbh: 0
    },
    organization: QuoteOrganizationEnum.Jamesway_SEA,
    created_at: '2021-03-11T19:40:28.731532Z',
    updated_at: '2021-03-11T19:40:38.242649Z'
  },
  {
    number: 259,
    revision: 1,
    language: 'en',
    latest: true,
    owner: 'Lamar Falconer',
    state: 8,
    type: 0,
    layout: 'Layout 1',
    project: 'Project 1',
    rfq_date: '2021-12-01',
    rfq_number: '123456',
    validity_date_range: 30,
    exchange_rate: 1.0,
    currency: 2,
    customer: {
      id: 3,
      name: 'ABALIOGLU LEZITA GIDA SAN. A.S',
      identifier: 'ABA0001',
      tax_id: '',
      is_same_billing_address: true,
      address: {
        id: 5,
        address1: 'BAGYURDU YENI MH.',
        address2: 'IZMRI ANKARA CD. NO:650/1',
        address3: '',
        address4: '',
        city: 'IZMIR 35743',
        region: '',
        country: 'TURKEY',
        postal_code: ''
      },
      ship_address: {
        id: 6,
        address1: 'BAGYURDU YENI MH.',
        address2: 'IZMRI ANKARA CD. NO:650/1',
        address3: '',
        address4: '',
        city: 'IZMIR 35743',
        region: '',
        country: 'TURKEY',
        postal_code: ''
      },
      contact: {
        id: 3,
        first_name: 'Lamar',
        last_name: 'Falconer',
        email: '',
        phone: ''
      }
    },
    region: null,
    ewg_discount_percent: 0.0,
    ewg_discount: 0.0,
    special_discount_percent: 0.0,
    special_discount: 0.0,

    equipment_subtotal: 0.0,
    subscription_first_year_discount: 0.0,
    subscription_yearly_subtotal: 0.0,

    commission_percent: 0.0,
    commission: 0.0,
    comments: '',
    categories: [
      {
        id: 345,
        module: 6,
        price: 3.0,
        global_discount_percentage: 0.0,
        accessory_discount_percentage: 0.0,
        first_year_subscription_discount_percentage: 100.0,
        discount: 0.0,
        products: [
          {
            id: 356,
            description: '',
            quantity: 1,
            price: 3.0,
            module: 6,
            configuration: 924
          }
        ],
        accessory_discount: 0.0,
        accessory_price: 3.0,
        global_discount: 0,
        global_price: 0
      }
    ],
    service_items: [],
    freight_items: [],
    extra_items: [],
    terms: [],
    payment_terms: [],
    rooms: [],
    capacity: {
      incubation_chiller_capacities_kw: 0,
      ventilation_chiller_capacities_kw: 0,
      incubation_boiler_capacities_kw: 0,
      ventilation_boiler_capacities_kw: 0,
      summer_temp_c: 0,
      summer_temp_f: 0,
      winter_temp_c: 0,
      winter_temp_f: 0,
      summer_rh: 0,
      winter_rh: 0,
      voltage_phase_frequency: '',
      boiler_type: '',

      ventilation_chiller_capacities_ton: 0,
      incubation_chiller_capacities_ton: 0,
      ventilation_boiler_capacities_mbh: 0,
      incubation_boiler_capacities_mbh: 0
    },
    organization: QuoteOrganizationEnum.Jamesway,
    created_at: '2021-03-11T19:41:35.403979Z',
    updated_at: '2021-03-11T19:41:49.725270Z'
  }
];

export const mockQuoteRevisionsData = (): IQuoteData[] => [
  {
    number: 263,
    revision: 1,
    language: 'en',
    latest: false,
    owner: 'Denisa Lehocky',
    state: 9,
    type: 0,
    layout: 'na',
    project: '123456 test',
    rfq_date: '2021-12-01',
    rfq_number: '123456',
    validity_date_range: 30,
    exchange_rate: 1.0,
    currency: 2,
    customer: {
      id: 7,
      name: 'Fake Customer',
      identifier: '',
      tax_id: '',
      is_same_billing_address: true,
      address: {
        id: 13,
        address1: '1770 Promontory Crescent',
        address2: '1770 Promontory Drive',
        address3: '',
        address4: '',
        city: 'Greeley',
        region: 'CO',
        country: 'United States',
        postal_code: '80634'
      },
      ship_address: {
        id: 14,
        address1: '1770 Promontory Crescent',
        address2: '1770 Promontory Drive',
        address3: '',
        address4: '',
        city: 'Greeley',
        region: 'CO',
        country: 'United States',
        postal_code: '80634'
      },
      contact: {
        id: 7,
        first_name: 'HHH',
        last_name: 'HHH',
        email: 'adam.brian@gsk.com',
        phone: ''
      }
    },
    region: null,
    ewg_discount_percent: 0.0,
    ewg_discount: 0.0,
    special_discount_percent: 0.0,
    special_discount: 0.0,
    commission_percent: 0.0,

    equipment_subtotal: 0.0,
    subscription_first_year_discount: 0.0,
    subscription_yearly_subtotal: 0.0,

    commission: 0.0,
    comments: '',
    categories: [
      {
        id: 349,
        module: 5,
        price: 607200.0,
        global_discount_percentage: 10.0,
        accessory_discount_percentage: 0.0,
        first_year_subscription_discount_percentage: 100.0,
        discount: 60720.0,
        products: [
          {
            id: 360,
            description: '',
            quantity: 1,
            price: 275200.0,
            module: 5,
            configuration: 947
          },
          {
            id: 361,
            description: '',
            quantity: 1,
            price: 332000.0,
            module: 5,
            configuration: 948
          }
        ],
        accessory_discount: 60720.0,
        accessory_price: 607200.0,
        global_discount: 0,
        global_price: 0
      }
    ],
    service_items: [
      {
        id: 111,
        template: null,
        title: 'Supervision of Installation',
        description:
          '<p>Installation Technician oversees complete installation. Coordinates and delegates work for installation crew: trains and provides support/guidance to same. (Customer provides 4-6 laborers)</p>',
        price: 12000.0,
        price_computation: null
      },
      {
        id: 112,
        template: null,
        title: 'Commissioning, Machine Startup and Training',
        description:
          '<p>Machines are started up and all outputs/inputs water, air, electrical, turning, all machine functions are tested. Connections, voltages and turning of racks are checked. First run is done to ensure proper machine operation. Hatchery personnel are trained on the operation of the machines.&nbsp;</p>',
        price: 23000.0,
        price_computation: null
      },
      {
        id: 113,
        template: null,
        title:
          'Monitoring of First Hatch, First Hatch Analysis and Hatch Optimization',
        description:
          '<p>Placement of eggs into the machines and training personnel on correct procedure of loading incubator racks. Transferring eggs from incubator to hatcher and training personnel on correct procedure. Train hatchery personnel on procedure of pulling birds correctly; checking random trays, reading the hatch. Training personnel on procedure of Residue Breakout.</p>',
        price: 12000.0,
        price_computation: null
      }
    ],
    freight_items: [
      {
        id: 53,
        template: null,
        title: 'Incoterms 2020 CIP Dhaka, Bangladesh',
        location: '',
        description:
          '<p>Note: Freight charges are quoted based on complete single shipment.&nbsp;Any deviations at&nbsp;the time of shipment may result in additional charges. *Freight Estimate Only. Freight to be confirmed at time of order finalization.</p>',
        price: 12000.0
      },
      {
        id: 54,
        template: null,
        title: 'SABER Products and Shipment Registration',
        location: '',
        description:
          '<p>SABER Product Registrations and Shipment Certificate fees are included in this proposal as estimates only. If additional fees are incurred, they will be added to the order at such time or invoiced at actual. Depending on the products shipped and the third party involved, Jamesway Inc. cannot be held responsible for any delays due to obtaining applicable SASO conformance documents.</p>',
        price: 0.0
      },
      {
        id: 55,
        template: null,
        title: 'SASO mandated fees are to be paid direct by the client',
        location: '',
        description: '',
        price: 0.0
      },
      {
        id: 56,
        template: null,
        title: 'Pre-shipment Inspection Estimate not included in proposal',
        location: '',
        description:
          '<p>Pre-shipment Inspection of goods may be required for the country.&nbsp;Such inspection fees are not included in this proposal. If such fees are incurred, they will be at the Buyer’s expense.&nbsp;It is the Buyer’s responsibility to notify Jamesway Inc. of a Pre-shipment Inspection requirement at time of proposal negotiation. Notification delay or non-performance may result in order delays. Jamesway Inc. will coordinate with the buyer and/or inspection agency to make the goods available for inspection. Depending on the nature of the inspection and the third party involved, Jamesway Inc. cannot be held responsible for any shipment dispatch delays.</p>',
        price: 0.0
      }
    ],
    extra_items: [
      {
        id: 17,
        title: 'Plenums',
        description: "<p>4' above plenum</p><p>drop ceiling</p><p><br></p>",
        price: 1200.0
      }
    ],
    terms: [
      {
        id: 398,
        template: null,
        title: 'Prices & Validity',
        order: 1,
        description:
          '<p>This Sales Proposal is valid for sixty (60) days, made without obligation by Jamesway Inc..&nbsp;Prices are quoted in United States Dollars (USD) unless otherwise noted and are exclusive of any sales, use, occupation, excise or similar tax in effect.</p><p>No changes will be accepted 4 weeks prior to exfactory date. If change request is within 4 weeks of the exfactory date, Jamesway Inc. reserves the right to re-evaluate the exfactory date and/or provide an updated exfactory date. Pricing will also be updated accordingly based on a Signed Order change request.1</p>'
      },
      {
        id: 399,
        template: null,
        title: 'Payment Terms',
        order: 2,
        description:
          '<p>Unless otherwise specified in the Sales Proposal Summary, the required methods of payment are either pre-payment in full by swift transfer, or irrevocable, confirmed, at sight letter of credit issued from an acceptable major financial institution.&nbsp;Exfactory date will be 8 weeks minimum from the receipt of Jamesway Inc. acceptable Letter of Credit. All other financial commitments must be finalized at least 4 weeks prior to the ex-factory date.</p>'
      },
      {
        id: 400,
        template: null,
        title: 'Delivery Terms & Costs',
        order: 3,
        description:
          '<p>Delivery Terms are noted on the Sales Proposal and are described and interpreted in accordance with Incoterms 2020.&nbsp;Prices quoted for delivery are estimates, and subject at all times to adjustment by Jamesway Inc. in order to reflect current transportation rates. Prices quoted are based on single complete shipment, any other variations to delivery may result in change to transportation fees quoted.&nbsp;</p>'
      },
      {
        id: 401,
        template: null,
        title: 'Trade Compliance',
        order: 4,
        description:
          '<p>SABER Product Registrations and Shipment Certificate fees are not included in this proposal. If such fees are incurred, they will be added to the order at such time or invoiced at actual. Depending on the products shipped and the third party involved, Jamesway Inc. cannot be held responsible for any delays due to obtaining applicable SASO conformance documents.</p>'
      },
      {
        id: 402,
        template: null,
        title: 'Pre-shipment Inspection',
        order: 5,
        description:
          '<p>Pre-shipment Inspection of goods may be required for the country.&nbsp;Such inspection fees are not included in this proposal. If such fees are incurred, they will be at the Buyer’s expense.&nbsp;It is the Buyer’s responsibility to notify Jamesway Inc. of a Pre-shipment Inspection requirement at time of proposal negotiation. Notification delay or non-performance may result in order delays. Jamesway Inc. will coordinate with the buyer and/or inspection agency to make the goods available for inspection. Depending on the nature of the inspection and the third party involved, Jamesway Inc. cannot be held responsible for any shipment dispatch delays.</p>'
      },
      {
        id: 403,
        template: null,
        title: 'Parts Warranty',
        order: 6,
        description:
          "<p>Jamesway Inc. will repair or replace, at Jamesway Inc.'s option, any defect in material or workmanship in any Jamesway Inc. manufactured part for a period of twelve (12) months from the date of shipment</p><p>This guarantee does not apply to sales of used equipment, to parts requiring replacement because of normal wear and tear, nor to products, accessories, parts, or attachments, which were not manufactured by Jamesway Inc. except to the extent of the guarantee provided by the actual manufacturer.</p><p>Jamesway Inc. does not guarantee any product or parts to meet local, municipal, state, provincial laws or regulations in the country of usage.</p>"
      },
      {
        id: 404,
        template: null,
        title: 'Equipment Warranty',
        order: 7,
        description:
          "<p>Jamesway Inc. will repair or replace, at Jamesway Inc.'s option, any defect in material or workmanship in any Jamesway Inc. manufactured part for a period of eighteen (18) months from date of shipment or twelve (12) months from the date of signature of the Completion Certificate, whichever occurs first, provided equipment is stored as per Jamesway Inc.’s specification.&nbsp;This warranty covers defects on parts, equipment and workmanship.</p><p>This guarantee does not apply to sales of used equipment, to parts requiring replacement because of normal wear and tear, nor to products, accessories, parts, or attachments which were not manufactured by Jamesway Inc. except to the extent of the guarantee provided by the actual manufacturer.</p><p>Jamesway Inc. does not guarantee any product or parts to meet local, municipal, state, provincial laws or regulations in the country of usage.&nbsp;</p>"
      },
      {
        id: 405,
        template: null,
        title: 'Storage',
        order: 8,
        description:
          '<p>In the event of storage of equipment prior to installation, the equipment shall be kept in a dry storage protected from natural elements:&nbsp;i.e. rain, snow, water, sand, wind.&nbsp;Failure to do so may affect the warranty. In the event the buyer delays the acceptance of goods/equipment without notice of 4 weeks prior to exfactory to Jamesway Inc. (i.e. building not ready. other scheduling conflicts, etc), storage/warehousing charges may apply in addition to applicable demurrage charges, rate subject to adjustment in order to reflect current storage/warehousing fees.&nbsp;</p>'
      },
      {
        id: 406,
        template: null,
        title: 'Installation',
        order: 9,
        description:
          '<p>This quotation does not include all necessary utility and ventilation equipment necessary for optimal performance of the equipment quoted. Jamesway Inc. can provide such equipment according to Jamesway Inc. specification in a separate quotation, or arrange for such a quotation from a certified provider.&nbsp;In any case, the customer is responsible providing HVAC and utilities installation including required ductwork, electrical wiring (power and control/sensor), piping &amp; plumbing (cooling &amp; heating water, humidification water) and compressed air.</p><p>Jamesway Inc. is not responsible for taxes, insurance, permits that may be required for installation.</p><p>Installation will comply to local regulations where possible and known but full compliance or the ability to obtain required local approvals is not guaranteed.</p><p>The site where the equipment is to be installed must match the requirements stated in the Platinum Incubator and Hatcher Room Floor Requirements issued by Jamesway Inc. by the local Regional Service Manager.</p><p>Jamesway Inc. is not responsible for the provision of required access and/or support platforms, forklift trucks or cranes necessary for unloading of equipment at site, and in particular, Jamesway Inc. is not responsible for unloading of equipment at site.</p><p>Jamesway Inc. installation technicians are not expected to engage in physical installation activities - activity is limited to installation supervison only.</p><p>The customer is responsible for building construction, any required modificatons and provision of acceptable drainage.</p><p>Customer is responsible for all local transportation for Jamesway Inc. and Jamesway Inc. sub-contracted installation technicians.&nbsp;Customer will also supply the required number of local laborers for physical installation of quoted equipment.</p><p>We strongly recommend to all customers that Supervision of Installation of your new equipment is provided by Jamesway Inc. Installation supervisors. </p><p>If customer decides that Supervision of Installation service is not required then Jamesway Inc.&nbsp;will not be responsible for the quality of installation of your equipment and the subsequent operational performance of your equipment. </p><p>Any subsequent request to Jamesway Inc.&nbsp;for remedial service will be charged accordingly at the applicable Service rates. </p><p>Parts &amp; their shipment to site when required for remedial work will be charged to customer. </p><p>Warranty on your equipment is not guaranteed when Supervision of Installation service is not provided by Jamesway Inc. </p><p>We strongly recommend that Installation Supervision is purchased by all our customers.</p>'
      },
      {
        id: 407,
        template: null,
        title: 'Force Majeure',
        order: 10,
        description:
          '<p>Should any circumstances arise which prevent complete or partial fulfillment by any of the Parties of their respective obligations under the present Contract, namely: fire, acts of God, war, military operations of any kind, blockade, prohibition of export or import or any other circumstances beyond the control of Parties, the time stipulated for the fulfillment of such obligations shall be extended for the period equal to that during which such circumstances will remain in force.</p><p>Should a situation of force majeure arise, the other party shall be informed by e-mail, fax or phone within two days. At the latest 15 days after the force majeure situation occurred, a confirmation shall be communicated to the other party by registered letter. Attached to the above letter shall be the confirmation of the local Chamber of Commerce of the country of force majeure. The cease of the force majeure situation must be communicated in the same way.</p><p>In case the delay in shipment due to existence of force-majeure circumstances exceeds 2 (two) weeks, the Buyer and the Seller shall conduct additional negotiations to work out further steps to be taken.</p>'
      },
      {
        id: 408,
        template: null,
        title: 'Errors & Omissions',
        order: 11,
        description:
          '<p>Errors and omissions are excepted from this Sales Proposal and the accuracy of the Sales Proposal is only to the extent of accuracy of information supplied to Jamesway Inc. in order to produce this proposal.</p>'
      }
    ],
    payment_terms: [],
    rooms: [],
    capacity: {
      incubation_chiller_capacities_kw: 0,
      ventilation_chiller_capacities_kw: 0,
      incubation_boiler_capacities_kw: 0,
      ventilation_boiler_capacities_kw: 0,
      summer_temp_c: 0,
      summer_temp_f: 0,
      winter_temp_c: 0,
      winter_temp_f: 0,
      summer_rh: 0,
      winter_rh: 0,
      voltage_phase_frequency: '',
      boiler_type: '',

      ventilation_chiller_capacities_ton: 0,
      incubation_chiller_capacities_ton: 0,
      ventilation_boiler_capacities_mbh: 0,
      incubation_boiler_capacities_mbh: 0
    },
    organization: QuoteOrganizationEnum.Jamesway_SEA,
    created_at: '2021-03-11T23:01:58.411304Z',
    updated_at: '2021-03-11T23:15:08.277463Z'
  },
  {
    number: 263,
    revision: 2,
    language: 'en',
    latest: false,
    owner: 'Denisa Lehocky',
    state: 8,
    type: 0,
    layout: 'na',
    project: '123456 test',
    rfq_date: '2021-12-01',
    rfq_number: '123456',
    validity_date_range: 30,
    exchange_rate: 1.0,
    currency: 2,
    customer: {
      id: 8,
      name: 'Fake Customer',
      identifier: '',
      tax_id: '',
      is_same_billing_address: true,
      address: {
        id: 15,
        address1: '1770 Promontory Crescent',
        address2: '1770 Promontory Drive',
        address3: '',
        address4: '',
        city: 'Greeley',
        region: 'CO',
        country: 'United States',
        postal_code: '80634'
      },
      ship_address: {
        id: 15,
        address1: '1770 Promontory Crescent',
        address2: '1770 Promontory Drive',
        address3: '',
        address4: '',
        city: 'Greeley',
        region: 'CO',
        country: 'United States',
        postal_code: '80634'
      },
      contact: {
        id: 8,
        first_name: 'HHH',
        last_name: 'HHH',
        email: 'adam.brian@gsk.com',
        phone: ''
      }
    },
    region: null,
    ewg_discount_percent: 0.0,
    ewg_discount: 0.0,
    special_discount_percent: 0.0,
    special_discount: 0.0,

    equipment_subtotal: 0.0,
    subscription_first_year_discount: 0.0,
    subscription_yearly_subtotal: 0.0,

    commission_percent: 0.0,
    commission: 0.0,
    comments: '',
    categories: [
      {
        id: 350,
        module: 5,
        price: 607200.0,
        global_discount_percentage: 10.0,
        accessory_discount_percentage: 0.0,
        first_year_subscription_discount_percentage: 100.0,
        discount: 60720.0,
        products: [
          {
            id: 362,
            description: '',
            quantity: 1,
            price: 275200.0,
            module: 5,
            configuration: 949
          },
          {
            id: 363,
            description: '',
            quantity: 1,
            price: 332000.0,
            module: 5,
            configuration: 950
          }
        ],
        accessory_discount: 60720.0,
        accessory_price: 607200.0,
        global_discount: 0,
        global_price: 0
      }
    ],
    service_items: [
      {
        id: 114,
        template: null,
        title: 'Supervision of Installation',
        description:
          '<p>Installation Technician oversees complete installation. Coordinates and delegates work for installation crew: trains and provides support/guidance to same. (Customer provides 4-6 laborers)</p>',
        price: 12000.0,
        price_computation: null
      },
      {
        id: 115,
        template: null,
        title: 'Commissioning, Machine Startup and Training',
        description:
          '<p>Machines are started up and all outputs/inputs water, air, electrical, turning, all machine functions are tested. Connections, voltages and turning of racks are checked. First run is done to ensure proper machine operation. Hatchery personnel are trained on the operation of the machines.&nbsp;</p>',
        price: 23000.0,
        price_computation: null
      },
      {
        id: 116,
        template: null,
        title:
          'Monitoring of First Hatch, First Hatch Analysis and Hatch Optimization',
        description:
          '<p>Placement of eggs into the machines and training personnel on correct procedure of loading incubator racks. Transferring eggs from incubator to hatcher and training personnel on correct procedure. Train hatchery personnel on procedure of pulling birds correctly; checking random trays, reading the hatch. Training personnel on procedure of Residue Breakout.</p>',
        price: 12000.0,
        price_computation: null
      }
    ],
    freight_items: [
      {
        id: 57,
        template: null,
        title: 'Incoterms 2020 CIP Dhaka, Bangladesh',
        location: '',
        description:
          '<p>Note: Freight charges are quoted based on complete single shipment.&nbsp;Any deviations at&nbsp;the time of shipment may result in additional charges. *Freight Estimate Only. Freight to be confirmed at time of order finalization.</p>',
        price: 12000.0
      },
      {
        id: 58,
        template: null,
        title: 'SABER Products and Shipment Registration',
        location: '',
        description:
          '<p>SABER Product Registrations and Shipment Certificate fees are included in this proposal as estimates only. If additional fees are incurred, they will be added to the order at such time or invoiced at actual. Depending on the products shipped and the third party involved, Jamesway Inc. cannot be held responsible for any delays due to obtaining applicable SASO conformance documents.</p>',
        price: 0.0
      },
      {
        id: 59,
        template: null,
        title: 'SASO mandated fees are to be paid direct by the client',
        location: '',
        description: '',
        price: 0.0
      },
      {
        id: 60,
        template: null,
        title: 'Pre-shipment Inspection Estimate not included in proposal',
        location: '',
        description:
          '<p>Pre-shipment Inspection of goods may be required for the country.&nbsp;Such inspection fees are not included in this proposal. If such fees are incurred, they will be at the Buyer’s expense.&nbsp;It is the Buyer’s responsibility to notify Jamesway Inc. of a Pre-shipment Inspection requirement at time of proposal negotiation. Notification delay or non-performance may result in order delays. Jamesway Inc. will coordinate with the buyer and/or inspection agency to make the goods available for inspection. Depending on the nature of the inspection and the third party involved, Jamesway Inc. cannot be held responsible for any shipment dispatch delays.</p>',
        price: 0.0
      }
    ],
    extra_items: [
      {
        id: 18,
        title: 'Plenums',
        description: "<p>4' above plenum</p><p>drop ceiling</p><p><br></p>",
        price: 1200.0
      }
    ],
    terms: [
      {
        id: 409,
        template: null,
        title: 'Prices & Validity',
        order: 1,
        description:
          '<p>This Sales Proposal is valid for sixty (60) days, made without obligation by Jamesway Inc..&nbsp;Prices are quoted in United States Dollars (USD) unless otherwise noted and are exclusive of any sales, use, occupation, excise or similar tax in effect.</p><p>No changes will be accepted 4 weeks prior to exfactory date. If change request is within 4 weeks of the exfactory date, Jamesway Inc. reserves the right to re-evaluate the exfactory date and/or provide an updated exfactory date. Pricing will also be updated accordingly based on a Signed Order change request.1</p>'
      },
      {
        id: 410,
        template: null,
        title: 'Payment Terms',
        order: 2,
        description:
          '<p>Unless otherwise specified in the Sales Proposal Summary, the required methods of payment are either pre-payment in full by swift transfer, or irrevocable, confirmed, at sight letter of credit issued from an acceptable major financial institution.&nbsp;Exfactory date will be 8 weeks minimum from the receipt of Jamesway Inc. acceptable Letter of Credit. All other financial commitments must be finalized at least 4 weeks prior to the ex-factory date.</p>'
      },
      {
        id: 411,
        template: null,
        title: 'Delivery Terms & Costs',
        order: 3,
        description:
          '<p>Delivery Terms are noted on the Sales Proposal and are described and interpreted in accordance with Incoterms 2020.&nbsp;Prices quoted for delivery are estimates, and subject at all times to adjustment by Jamesway Inc. in order to reflect current transportation rates. Prices quoted are based on single complete shipment, any other variations to delivery may result in change to transportation fees quoted.&nbsp;</p>'
      },
      {
        id: 412,
        template: null,
        title: 'Trade Compliance',
        order: 4,
        description:
          '<p>SABER Product Registrations and Shipment Certificate fees are not included in this proposal. If such fees are incurred, they will be added to the order at such time or invoiced at actual. Depending on the products shipped and the third party involved, Jamesway Inc. cannot be held responsible for any delays due to obtaining applicable SASO conformance documents.</p>'
      },
      {
        id: 413,
        template: null,
        title: 'Pre-shipment Inspection',
        order: 5,
        description:
          '<p>Pre-shipment Inspection of goods may be required for the country.&nbsp;Such inspection fees are not included in this proposal. If such fees are incurred, they will be at the Buyer’s expense.&nbsp;It is the Buyer’s responsibility to notify Jamesway Inc. of a Pre-shipment Inspection requirement at time of proposal negotiation. Notification delay or non-performance may result in order delays. Jamesway Inc. will coordinate with the buyer and/or inspection agency to make the goods available for inspection. Depending on the nature of the inspection and the third party involved, Jamesway Inc. cannot be held responsible for any shipment dispatch delays.</p>'
      },
      {
        id: 414,
        template: null,
        title: 'Parts Warranty',
        order: 6,
        description:
          "<p>Jamesway Inc. will repair or replace, at Jamesway Inc.'s option, any defect in material or workmanship in any Jamesway Inc. manufactured part for a period of twelve (12) months from the date of shipment</p><p>This guarantee does not apply to sales of used equipment, to parts requiring replacement because of normal wear and tear, nor to products, accessories, parts, or attachments, which were not manufactured by Jamesway Inc. except to the extent of the guarantee provided by the actual manufacturer.</p><p>Jamesway Inc. does not guarantee any product or parts to meet local, municipal, state, provincial laws or regulations in the country of usage.</p>"
      },
      {
        id: 415,
        template: null,
        title: 'Equipment Warranty',
        order: 7,
        description:
          "<p>Jamesway Inc. will repair or replace, at Jamesway Inc.'s option, any defect in material or workmanship in any Jamesway Inc. manufactured part for a period of eighteen (18) months from date of shipment or twelve (12) months from the date of signature of the Completion Certificate, whichever occurs first, provided equipment is stored as per Jamesway Inc.’s specification.&nbsp;This warranty covers defects on parts, equipment and workmanship.</p><p>This guarantee does not apply to sales of used equipment, to parts requiring replacement because of normal wear and tear, nor to products, accessories, parts, or attachments which were not manufactured by Jamesway Inc. except to the extent of the guarantee provided by the actual manufacturer.</p><p>Jamesway Inc. does not guarantee any product or parts to meet local, municipal, state, provincial laws or regulations in the country of usage.&nbsp;</p>"
      },
      {
        id: 416,
        template: null,
        title: 'Storage',
        order: 8,
        description:
          '<p>In the event of storage of equipment prior to installation, the equipment shall be kept in a dry storage protected from natural elements:&nbsp;i.e. rain, snow, water, sand, wind.&nbsp;Failure to do so may affect the warranty. In the event the buyer delays the acceptance of goods/equipment without notice of 4 weeks prior to exfactory to Jamesway Inc. (i.e. building not ready. other scheduling conflicts, etc), storage/warehousing charges may apply in addition to applicable demurrage charges, rate subject to adjustment in order to reflect current storage/warehousing fees.&nbsp;</p>'
      },
      {
        id: 417,
        template: null,
        title: 'Installation',
        order: 9,
        description:
          '<p>This quotation does not include all necessary utility and ventilation equipment necessary for optimal performance of the equipment quoted. Jamesway Inc. can provide such equipment according to Jamesway Inc. specification in a separate quotation, or arrange for such a quotation from a certified provider.&nbsp;In any case, the customer is responsible providing HVAC and utilities installation including required ductwork, electrical wiring (power and control/sensor), piping &amp; plumbing (cooling &amp; heating water, humidification water) and compressed air.</p><p>Jamesway Inc. is not responsible for taxes, insurance, permits that may be required for installation.</p><p>Installation will comply to local regulations where possible and known but full compliance or the ability to obtain required local approvals is not guaranteed.</p><p>The site where the equipment is to be installed must match the requirements stated in the Platinum Incubator and Hatcher Room Floor Requirements issued by Jamesway Inc. by the local Regional Service Manager.</p><p>Jamesway Inc. is not responsible for the provision of required access and/or support platforms, forklift trucks or cranes necessary for unloading of equipment at site, and in particular, Jamesway Inc. is not responsible for unloading of equipment at site.</p><p>Jamesway Inc. installation technicians are not expected to engage in physical installation activities - activity is limited to installation supervison only.</p><p>The customer is responsible for building construction, any required modificatons and provision of acceptable drainage.</p><p>Customer is responsible for all local transportation for Jamesway Inc. and Jamesway Inc. sub-contracted installation technicians.&nbsp;Customer will also supply the required number of local laborers for physical installation of quoted equipment.</p><p>We strongly recommend to all customers that Supervision of Installation of your new equipment is provided by Jamesway Inc. Installation supervisors. </p><p>If customer decides that Supervision of Installation service is not required then Jamesway Inc.&nbsp;will not be responsible for the quality of installation of your equipment and the subsequent operational performance of your equipment. </p><p>Any subsequent request to Jamesway Inc.&nbsp;for remedial service will be charged accordingly at the applicable Service rates. </p><p>Parts &amp; their shipment to site when required for remedial work will be charged to customer. </p><p>Warranty on your equipment is not guaranteed when Supervision of Installation service is not provided by Jamesway Inc. </p><p>We strongly recommend that Installation Supervision is purchased by all our customers.</p>'
      },
      {
        id: 418,
        template: null,
        title: 'Force Majeure',
        order: 10,
        description:
          '<p>Should any circumstances arise which prevent complete or partial fulfillment by any of the Parties of their respective obligations under the present Contract, namely: fire, acts of God, war, military operations of any kind, blockade, prohibition of export or import or any other circumstances beyond the control of Parties, the time stipulated for the fulfillment of such obligations shall be extended for the period equal to that during which such circumstances will remain in force.</p><p>Should a situation of force majeure arise, the other party shall be informed by e-mail, fax or phone within two days. At the latest 15 days after the force majeure situation occurred, a confirmation shall be communicated to the other party by registered letter. Attached to the above letter shall be the confirmation of the local Chamber of Commerce of the country of force majeure. The cease of the force majeure situation must be communicated in the same way.</p><p>In case the delay in shipment due to existence of force-majeure circumstances exceeds 2 (two) weeks, the Buyer and the Seller shall conduct additional negotiations to work out further steps to be taken.</p>'
      },
      {
        id: 419,
        template: null,
        title: 'Errors & Omissions',
        order: 11,
        description:
          '<p>Errors and omissions are excepted from this Sales Proposal and the accuracy of the Sales Proposal is only to the extent of accuracy of information supplied to Jamesway Inc. in order to produce this proposal.</p>'
      }
    ],
    payment_terms: [],
    rooms: [],
    capacity: {
      incubation_chiller_capacities_kw: 0,
      ventilation_chiller_capacities_kw: 0,
      incubation_boiler_capacities_kw: 0,
      ventilation_boiler_capacities_kw: 0,
      summer_temp_c: 0,
      summer_temp_f: 0,
      winter_temp_c: 0,
      winter_temp_f: 0,
      summer_rh: 0,
      winter_rh: 0,
      voltage_phase_frequency: '',
      boiler_type: '',

      ventilation_chiller_capacities_ton: 0,
      incubation_chiller_capacities_ton: 0,
      ventilation_boiler_capacities_mbh: 0,
      incubation_boiler_capacities_mbh: 0
    },
    organization: QuoteOrganizationEnum.Jamesway,
    created_at: '2021-03-11T23:15:08.241479Z',
    updated_at: '2021-03-11T23:17:09.580467Z'
  }
];

export const mockQuoteActivitiesData = (): ITransition[] => [
  {
    id: 247,
    timestamp: '2021-03-11T23:05:34.135094Z',
    transition: 'submit',
    user: 'Denisa Lehocky',
    source_state: '0',
    state: '1'
  },
  {
    id: 248,
    timestamp: '2021-03-11T23:05:35.502187Z',
    transition: 'start_review',
    user: 'Denisa Lehocky',
    source_state: '1',
    state: '2'
  },
  {
    id: 249,
    timestamp: '2021-03-11T23:13:01.462367Z',
    transition: 'approve',
    user: 'Denisa Lehocky',
    source_state: '2',
    state: '6'
  }
];

export const mockQuotes = (data: IQuoteData[] = mockQuotesData()): IQuote[] =>
  data.map(item => new Quote(item));

export const mockQuoteRevisions = (
  data: IQuoteData[] = mockQuoteRevisionsData()
): IQuote[] => data.map(item => new Quote(item));

export const mockQuoteActivities = (
  data: ITransition[] = mockQuoteActivitiesData()
): ITransition[] => data;

export const mockQuotePaginatedData = (): IQuotePaginatedListData => {
  return {
    count: mockQuotesData().length,
    next: '',
    previous: '',
    results: mockQuotesData()
  };
};
